import _axios from "@/axios";
import { reactive } from "@vue/composition-api";
import { handleFormErrors } from "./form-error";
import { showSnackBar } from "@/composables/snackbar";

export function usePortalOptions() {
  const portalOptionData = reactive({
    isUpdated: false,
    portalOptionsForm: {},
    dialog: false,
    portalOptionFormRef: null,
    nameRules: [(v) => !!v || "La template doit avoir un nom"],
    vatRules: [(v) => !!v || "La TVA est requise"],
    isLoading: false,
  });

  function updatePortalOptions(portalOptions) {
    portalOptionData.isLoading = true;
    portalOptionData.isUpdated = false;
    portalOptionData.isLoading = true;
    if (portalOptionData.portalOptionFormRef != null) {
      const isValid = portalOptionData.portalOptionFormRef.validate();
      if (!isValid) {
        portalOptionData.isLoading = false;
        portalOptionData.isLoading = false;
        return;
      }
    }

    return _axios
      .put(
        "/update-portal-options/" + portalOptions.id,
        portalOptionData.portalOptionsForm
      )
      .then(() => {
        portalOptionData.dialog = false;
        portalOptionData.isUpdated = true;

        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          portalOptionData,
          portalOptionData.portalOptionFormRef
        );
      })
      .finally(() => {
        portalOptionData.isLoading = false;
        portalOptionData.isLoading = false;
      });
  }

  return {
    updatePortalOptions,
    portalOptionData,
  };
}
